import { render, staticRenderFns } from "./GroupTypeWidget.vue?vue&type=template&id=37c85978"
import script from "./GroupTypeWidget.vue?vue&type=script&lang=js"
export * from "./GroupTypeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports